import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, InputField } from '@unite-us/ui';
import { get, isEmpty, first } from 'lodash';
import { Field, Form } from 'react-final-form';
import { callbacks, getAdapter, trackEvent } from '../../../config/api';
import callOrLog from '../../../constants/callOrLog';
import { FACESHEET } from '../../../constants/eventConstants';
import { isRequired } from '../../utils/validations';
import { composeValidators } from '../../utils/composeValidators';
function SSNForm(props) {
  var contact = props.contact;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var contact, contactId, ssn;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            contact = props.contact;
            contactId = get(contact, 'id');
            ssn = value.ssn ? value.ssn.replace(/\D+/ig, '') : null;
            _context.next = 5;
            return getAdapter('coreApi').updateRecord("person", contactId, {
              ssn: ssn
            });
          case 5:
            callOrLog(function () {
              return trackEvent(FACESHEET.ssnUpdated);
            });
            props.closeModal();
            callbacks.onClientSaved();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var formValidator = {
    ssnValidate: function ssnValidate(values) {
      var isReq = isRequired(values);
      if (isReq !== null) {
        if (isEmpty(formErrors)) {
          setFormErrors(isReq);
        }
        return isReq;
      }
      return '';
    },
    ssnNineDigits: function ssnNineDigits(values) {
      var errors = {};
      var reg = /\d{3}-\d{2}-\d{4}/;
      if (!reg.test(values)) {
        errors.ssn_invalid = 'SSN should be 9 digits';
        setFormErrors(errors.ssn_invalid);
        return errors.ssn_invalid;
      } else {
        return null;
      }
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: contact,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        submitting = _ref2.submitting;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: "content-with-actions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "ssn",
        validate: composeValidators(formValidator.ssnValidate, formValidator.ssnNineDigits)
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          id: "ssn-input",
          label: "Social Security Number",
          placeholder: "*** - ** - ".concat(contact.ssn_last4 || '****'),
          mask: "999-99-9999",
          inline: false
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-ssn-cancel-btn",
        onClick: props.closeModal,
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-ssn-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        onClick: function onClick() {
          if (!isEmpty(formErrors)) {
            setTimeout(function () {
              var ssnModal = document.getElementById('edit-ssn-modal');
              var focusableErr = first(ssnModal === null || ssnModal === void 0 ? void 0 : ssnModal.getElementsByTagName('input'));
              if (focusableErr) {
                focusableErr.ariaLabel = formErrors;
              }
              focusableErr === null || focusableErr === void 0 || focusableErr.focus();
              setFormErrors({});
            }, 300);
          } else if (first(document.getElementsByClassName('ui-form-field--has-error'))) {
            var ssnModal = document.getElementById('edit-ssn-modal');
            var focusableErr = first(ssnModal === null || ssnModal === void 0 ? void 0 : ssnModal.getElementsByTagName('input'));
            focusableErr === null || focusableErr === void 0 || focusableErr.focus();
          }
          handleSubmit();
        }
      }))));
    }
  });
}
SSNForm.propTypes = {
  closeModal: PropTypes.func,
  contact: PropTypes.object.isRequired
};
SSNForm.defaultProps = {
  contact: {}
};
export default SSNForm;
//# sourceMappingURL=SSNForm.js.map